import React from "react";
import styled from "@emotion/styled";
import { SellerInfo } from "@pages/seller/_components";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
});

const Seller = () => {
  return (
    <Container>
      <SellerInfo />
    </Container>
  );
};

export default Seller;
